const TENANT = process.env.NEXT_PUBLIC_TENANT || 'default';

const TENANT_CONFIGS = {
  qmee: {
    accepted: ['en-us', 'en-gb', 'en-ca', 'en-au', 'de-de', 'fr-fr'],
    default: 'en-us',
  },
  default: {
    accepted: ['en', 'ar', 'hi', 'fr', 'bn'],
    default: 'en',
  },
};

// Select config based on tenant, fallback to default if not found
const config = TENANT_CONFIGS[TENANT] || TENANT_CONFIGS.default;

const ACCEPTED_LOCALES = config.accepted;
const DEFAULT_LOCALE = config.default;
const RTL_LOCALES = ['ar'];

export { ACCEPTED_LOCALES, DEFAULT_LOCALE, RTL_LOCALES };

const locales = {
  ACCEPTED_LOCALES,
  DEFAULT_LOCALE,
  RTL_LOCALES,
};

export default locales;
